import React, { useState } from "react";
import { formatLocal } from "../utils/dateHelpers";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface TrustCallDebugTabProps { data: any; }

function formatPhoneE164(v: unknown): string {
  if (!v) return "\u2014";
  let digits = String(v).replace(/\D/g, "");
  if (digits.length === 11 && digits[0] === "1") digits = digits.substring(1);
  if (digits.length === 10) return `+1 ${digits.substring(0, 3)} ${digits.substring(3, 6)} ${digits.substring(6)}`;
  return String(v);
}

const TrustCallDebugTab: React.FC<TrustCallDebugTabProps> = ({ data }) => {
  const [expandedTc, setExpandedTc] = useState<Set<number>>(new Set());
  const [expandedLogs, setExpandedLogs] = useState<Set<number>>(new Set());

  const toggleTc = (idx: number) => setExpandedTc((p) => { const n = new Set(p); if (n.has(idx)) n.delete(idx); else n.add(idx); return n; });
  const toggleLog = (idx: number) => setExpandedLogs((p) => { const n = new Set(p); if (n.has(idx)) n.delete(idx); else n.add(idx); return n; });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const trustCallRows: any[] = data?.trustCallRows || [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dialerLogs: any[] = data?.dialerLogs || [];

  return (
    <div style={{ paddingTop: 10 }}>
      {/* TrustCall Rows — collapsible */}
      <h5>TrustCall Rows</h5>
      {trustCallRows.length === 0 ? (
        <div className="alert alert-info">No TrustCall rows found for this phone number.</div>
      ) : (
        trustCallRows.map((row, idx) => {
          const isOpen = expandedTc.has(idx);
          return (
            <div className="card mb-3" key={idx}>
              <div
                className="card-header tc-json-block"
                style={{ cursor: "pointer" }}
                onClick={() => toggleTc(idx)}
              >
                <strong>TrustCall #{row.trustCallId || idx}</strong>
                {" "}<small className="text-muted">acctId: {row.acctId || ""}</small>
                <span className="float-end">
                  <span className={`k-icon ${isOpen ? "k-i-arrow-chevron-up" : "k-i-arrow-chevron-down"}`} />
                </span>
              </div>
              {isOpen && (
                <div className="card-body p-0">
                  <pre className="mb-0 p-3 tc-json-block" style={{ maxHeight: 400, overflow: "auto", fontSize: 12 }}>
                    {JSON.stringify(row, null, 2)}
                  </pre>
                </div>
              )}
            </div>
          );
        })
      )}

      {/* Dialer Logs (Last 30) */}
      <h5 className="mt-4">Dialer Logs (Last 30)</h5>
      {dialerLogs.length === 0 ? (
        <div className="alert alert-info">No dialer logs found for this phone number.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm table-striped align-middle">
            <thead>
              <tr><th>Log ID</th><th>Initiated</th><th>Duration</th><th>Array Device</th><th>Queue</th><th>Queued</th><th>Completed</th><th></th></tr>
            </thead>
            <tbody>
              {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
              {dialerLogs.map((log: any, idx: number) => {
                const initiated = log.initiatedCallOn ? formatLocal(new Date(log.initiatedCallOn)) : "\u2014";
                const completed = log.callCompletedAt ? formatLocal(new Date(log.callCompletedAt)) : "\u2014";
                const queued = log.timeQueued ? formatLocal(new Date(log.timeQueued)) : "\u2014";
                const device = formatPhoneE164(log.numberToDial);
                let duration = "\u2014";
                if (log.initiatedCallOn && log.callCompletedAt) {
                  const diffSecs = Math.round((new Date(log.callCompletedAt).getTime() - new Date(log.initiatedCallOn).getTime()) / 1000);
                  if (diffSecs >= 0) duration = diffSecs + "s";
                }
                const isOpen = expandedLogs.has(idx);
                const logJson = JSON.stringify(log, null, 2).replace(/api_key=[^&"\\]+/g, "api_key=***");
                return (
                  <React.Fragment key={idx}>
                    <tr>
                      <td>{log.logId}</td>
                      <td>{initiated}</td>
                      <td>{duration}</td>
                      <td>{device}</td>
                      <td>{log.queueName || "\u2014"}</td>
                      <td>{queued}</td>
                      <td>{completed}</td>
                      <td><a href="#" className="text-muted" style={{ fontSize: 11 }} onClick={(e) => { e.preventDefault(); toggleLog(idx); }}>JSON</a></td>
                    </tr>
                    {isOpen && (
                      <tr><td colSpan={8} className="p-0">
                        <pre className="tc-json-block p-2 m-0 small" style={{ maxHeight: 300, overflow: "auto", whiteSpace: "pre-wrap" }}>{logJson}</pre>
                      </td></tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TrustCallDebugTab;
